(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["currency-symbol-clarity"] && !Shopify.designMode) return;
  try {
    (() => {
    const currencyCode = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    const prefix = {
      AUD: 'A$',
      CAD: 'CA$',
      NZD: 'NZ$',
      SGD: 'S$',
    }[currencyCode];

    if (!prefix) return;

    const pricePattern = /(^|[^A-Z])\$(?=\s?\d)/g;
    const excludedParents = 'script, style, textarea';

    const formatTextNode = (node) => {
      if (node.parentElement && node.parentElement.closest(excludedParents)) return;

      const currentValue = node.nodeValue;
      const nextValue = currentValue.replace(pricePattern, (match, leadingCharacter) => {
        return `${leadingCharacter}${prefix}`;
      });

      if (nextValue !== currentValue) node.nodeValue = nextValue;
    };

    const formatNode = (root) => {
      if (root.nodeType === Node.TEXT_NODE) {
        formatTextNode(root);
        return;
      }

      if (root.nodeType !== Node.ELEMENT_NODE) return;

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let textNode;

      while ((textNode = walker.nextNode())) {
        formatTextNode(textNode);
      }
    };

    formatNode(document.body);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          formatTextNode(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(formatNode);
      });
    }).observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["style-it-with"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('style-it-with')) {
  customElements.define(
    'style-it-with',
    class StyleItWith extends HTMLElement {
      connectedCallback() {
        this.addButton = this.querySelector('[data-style-it-with-add]');
        this.errorElement = this.querySelector('[data-style-it-with-error]');
        this.totalElement = this.querySelector('[data-style-it-with-total]');
        this.spinner = this.querySelector('.loading__spinner');
        this.items = Array.from(this.querySelectorAll('[data-style-it-with-item]'));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.isLoading = false;

        this.addButton?.addEventListener('click', this.addSelectedItems.bind(this));
        this.addEventListener('change', this.handleChange.bind(this));

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.handleVariantChange.bind(this)
          );
        }

        this.updateState();
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      handleChange(event) {
        const target = event.target;
        const item = target?.closest?.('[data-style-it-with-item]');

        if (!item) return;

        if (target?.matches?.('[data-style-it-with-radio]')) {
          const select = item.querySelector('[data-style-it-with-select]');

          if (select) {
            select.value = target.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }

          return;
        }

        if (target.matches('[data-style-it-with-select]')) {
          this.updateItemAvailability(item);
          this.updateState();
          return;
        }

        if (target.matches('[data-style-it-with-checkbox]')) {
          this.updateState();
        }
      }

      handleVariantChange(event) {
        const variant = event?.data?.variant;
        const sectionId = event?.data?.sectionId;
        const currentItem = this.querySelector('[data-current-product]');

        if (!variant || !currentItem || currentItem.dataset.sectionId !== sectionId) return;

        const select = currentItem.querySelector('[data-style-it-with-select]');
        if (!select) return;

        const option = select.querySelector(`option[value="${variant.id}"]`);
        if (!option) return;

        select.value = String(variant.id);
        option.dataset.price = variant.price;
        option.dataset.available = String(variant.available);
        option.disabled = !variant.available;
        select.dispatchEvent(new Event('change', { bubbles: true }));

        this.updateItemAvailability(currentItem);
        this.updateState();
      }

      updateItemAvailability(item) {
        const checkbox = item.querySelector('[data-style-it-with-checkbox]');
        const select = item.querySelector('[data-style-it-with-select]');
        const selectedOption = select?.selectedOptions?.[0];
        const available = selectedOption?.dataset.available !== 'false' && !selectedOption?.disabled;

        if (!checkbox) return;

        checkbox.disabled = !available;
        if (!available) checkbox.checked = false;
      }

      updateState() {
        let total = 0;
        let selectedCount = 0;

        this.items.forEach((item) => {
          const checkbox = item.querySelector('[data-style-it-with-checkbox]');
          const select = item.querySelector('[data-style-it-with-select]');
          const selectedOption = select?.selectedOptions?.[0];
          const price = Number(selectedOption?.dataset.price || 0);
          const priceElement = item.querySelector('[data-style-it-with-price]');
          const available = selectedOption?.dataset.available !== 'false' && !selectedOption?.disabled;

          if (priceElement) {
            priceElement.textContent = this.formatMoney(price);
          }

          if (checkbox) {
            checkbox.disabled = !available;
            if (!available) checkbox.checked = false;
          }

          if (checkbox?.checked && !checkbox.disabled && selectedOption?.value) {
            total += price;
            selectedCount += 1;
          }
        });

        if (this.totalElement) {
          this.totalElement.textContent = this.formatMoney(total);
        }

        if (this.addButton) {
          const disabled = selectedCount === 0 || this.isLoading;
          this.addButton.disabled = disabled;
          this.addButton.toggleAttribute('aria-disabled', disabled);
        }
      }

      async addSelectedItems() {
        const selectedProducts = this.getSelectedProducts();

        if (selectedProducts.length === 0) {
          this.showError(this.dataset.emptyText || window.cartStrings?.error || 'Select at least one item.');
          return;
        }

        this.setLoading(true);
        this.showError('');

        try {
          const body = {
            items: selectedProducts.map((product) => ({
              id: product.variantId,
              quantity: 1,
            })),
          };

          if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
            body.sections = this.cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;

            if (typeof this.cart.setActiveElement === 'function') {
              this.cart.setActiveElement(document.activeElement);
            }
          }

          const response = await fetch(this.getCartAddUrl(), {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          });

          const parsed = await this.parseCartResponse(response);

          if (!response.ok || parsed.status) {
            throw new Error(parsed.description || parsed.message || window.cartStrings?.error || 'Error');
          }

          if (this.shouldRenderBundleNotification(parsed) && await this.renderBundleNotification(parsed, selectedProducts)) {
            return;
          }

          if (this.cart && typeof this.cart.renderContents === 'function') {
            this.cart.renderContents(parsed);
          } else {
            window.location = window.routes.cart_url || '/cart';
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'style-it-with',
              cartData: parsed,
            });
          }
        } catch (error) {
          console.error(error);
          this.showError(error.message || window.cartStrings?.error || 'Error');
        } finally {
          this.setLoading(false);
        }
      }

      shouldRenderBundleNotification(parsed) {
        return this.cart?.matches?.('cart-notification') && Array.isArray(parsed.items) && parsed.items.length > 1;
      }

      async renderBundleNotification(parsed, selectedProducts) {
        const notification = this.cart;
        const productElement = document.getElementById('cart-notification-product');

        if (!notification || !productElement) return false;

        notification.notification?.classList.add('cart-notification--multiple-products');
        productElement.classList.add('cart-notification-product--multiple');
        productElement.innerHTML = selectedProducts
          .map((product) => this.getBundleNotificationMarkup(product))
          .join('');

        this.renderNotificationSection(parsed, 'cart-notification-button');
        this.renderNotificationSection(parsed, 'cart-icon-bubble');

        if (!parsed.sections?.['cart-notification-button']) {
          await this.updateFallbackCartCount();
        }

        if (notification.header) notification.header.reveal();
        notification.open();
        return true;
      }

      renderNotificationSection(parsed, sectionId) {
        const sectionElement = document.getElementById(sectionId);
        const sectionHtml = parsed.sections?.[sectionId];

        if (!sectionElement || !sectionHtml || typeof this.cart?.getSectionInnerHTML !== 'function') return;

        sectionElement.innerHTML = this.cart.getSectionInnerHTML(sectionHtml);
      }

      getBundleNotificationMarkup(product) {
        const variantTitle = product.variantTitle && product.variantTitle.toLowerCase() !== 'default title'
          ? product.variantTitle
          : '';

        return `
          <div class="cart-item">
            ${
              product.imageSrc
                ? `<div class="cart-notification-product__image global-media-settings">
                    <img src="${this.escapeAttribute(product.imageSrc)}" alt="${this.escapeAttribute(product.imageAlt)}" width="70" height="70" loading="lazy">
                  </div>`
                : ''
            }
            <div>
              <h3 class="cart-notification-product__name h4">${this.escapeHTML(product.title)}</h3>
              ${
                variantTitle
                  ? `<dl>
                      <div class="product-option">
                        <dt>Size:</dt>
                        <dd>${this.escapeHTML(variantTitle)}</dd>
                      </div>
                    </dl>`
                  : '<dl></dl>'
              }
            </div>
          </div>
        `;
      }

      async updateFallbackCartCount() {
        const button = document.getElementById('cart-notification-button');

        if (!button) return;

        try {
          const response = await fetch(`${window.routes.cart_url || '/cart'}.js`);
          const cart = await response.json();

          if (cart?.item_count) {
            button.textContent = button.textContent.replace(/\(\d+\)/, '').trim() + ` (${cart.item_count})`;
          }
        } catch (error) {
          console.error(error);
        }
      }

      getSelectedProducts() {
        return this.items
          .filter((item) => {
            const checkbox = item.querySelector('[data-style-it-with-checkbox]');
            return checkbox?.checked && !checkbox.disabled;
          })
          .map((item) => {
            const select = item.querySelector('[data-style-it-with-select]');
            const selectedOption = select?.selectedOptions?.[0];
            const image = item.querySelector('.style-it-with__image');
            const title = item.querySelector('.style-it-with__title')?.textContent?.trim() || '';

            return {
              variantId: Number(select?.value || 0),
              title,
              variantTitle: selectedOption?.textContent?.trim() || '',
              imageAlt: image?.getAttribute('alt') || title,
              imageSrc: image?.currentSrc || image?.src || '',
            };
          })
          .filter((item) => item.variantId);
      }

      getCartAddUrl() {
        const cartAddUrl = window.routes.cart_add_url || '/cart/add';
        return cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl.replace(/\/$/, '')}.js`;
      }

      async parseCartResponse(response) {
        const responseText = await response.text();

        try {
          return JSON.parse(responseText);
        } catch (error) {
          console.error(error);
          return {
            status: response.status || 500,
            message: window.cartStrings?.error || 'Error',
            description: responseText ? responseText.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim() : '',
          };
        }
      }

      setLoading(isLoading) {
        this.isLoading = isLoading;

        if (this.addButton) {
          this.addButton.classList.toggle('loading', isLoading);
          this.addButton.toggleAttribute('aria-busy', isLoading);
        }

        if (this.spinner) {
          this.spinner.classList.toggle('hidden', !isLoading);
        }

        this.updateState();
      }

      showError(message) {
        if (!this.errorElement) return;

        this.errorElement.textContent = message || '';
        this.errorElement.hidden = !message;
      }

      escapeHTML(value) {
        return String(value || '').replace(/[&<>"']/g, (character) => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;',
        })[character]);
      }

      escapeAttribute(value) {
        return this.escapeHTML(value).replace(/`/g, '&#096;');
      }

      formatMoney(cents) {
        const amount = Number(cents || 0) / 100;

        return new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.dataset.currency || 'USD',
          minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
          maximumFractionDigits: 2,
        })
          .format(amount)
          .replace(/\u00a0/g, ' ');
      }
    }
  );
}
  } catch(e) { console.error(e); }
})();

})();
